const BACKUP_ONBOARDING_STEP = 'backupOnboardingStep';

const steps = ['details', 'members', 'notification-settings', 'storage-settings', 'summary'] as const;

export type IOnboardingStep = (typeof steps)[number];

export const getBackupOnboardingStep = (backupId: string): IOnboardingStep | null => {
  const step = localStorage.getItem(`${BACKUP_ONBOARDING_STEP}-${backupId}`) as IOnboardingStep;

  return steps.includes(step) ? step : null;
};

export const setBackupOnboardingStep = (backupId: string, step: IOnboardingStep) =>
  localStorage.setItem(`${BACKUP_ONBOARDING_STEP}-${backupId}`, step);

export const resetBackupOnboardingStep = (backupId: string) =>
  localStorage.removeItem(`${BACKUP_ONBOARDING_STEP}-${backupId}`);
